export default __webpack_public_path__ + "static/media/compartilhar-icon.961fec15.svg";